import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';

import { ChatContentComponent } from '../chat-content/chat-content.component';
import { AppPermissionsService } from '@common/services';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-chat-floating-button',
    templateUrl: './chat-floating-button.component.html',
    styleUrls: ['./chat-floating-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ChatFloatingButtonComponent implements OnInit, OnDestroy{

  public showHideOpenAi: boolean = false;
  public canSeeAssistant: boolean = false;

  @Input() source: string;

  // Childs
  @ViewChild(ChatContentComponent) chatContentComponent: ChatContentComponent;
  @ViewChild('popoverBix')popoverBix: NgbPopover;

  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   */
  constructor(private _permissionService: AppPermissionsService){
    this._unsubscribeAll = new Subject();
  }

  /**
   * OnInit
   */
  ngOnInit(){
    this._permissionService.onPermissionsChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      if(res){
        this.canSeeAssistant = this._permissionService.hasPermissionByUrl(`pages/chat#Floating`, "READ");
      }
    });
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.popoverBix) {
        this.popoverBix.open();
      }
    }, 1000);
  }

  /**
   * Muestra u oculta el chat de open ai
   */
  showHide(){
    this.showHideOpenAi  = !this.showHideOpenAi;

    // Mueve el scroll hasta abajo de los chats
    if (this.chatContentComponent){
      this.chatContentComponent.scrollToBottom();
    }
    
  }

}
